var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.canvasWidth + 'px', height: _vm.height })},[_c('canvas',{ref:_vm.barRef})])}
var staticRenderFns = []

export { render, staticRenderFns }